var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isAuthenticated) ? [(_vm.contains('doctor')) ? _c('home-doctor') : (_vm.contains('receptionist') || _vm.contains('nurse')) ? _c('home-receptionist') : _vm._e()] : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74a64a88","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 419
// module chunks = 0